<template>
  <div class="auth-wrapper auth-v2">
    <b-row class="auth-inner m-0">
      <!-- Brand logo-->
      <b-link class="brand-logo">
        <app-logo />
      </b-link>
      <!-- /Brand logo-->
      <!-- Left Text-->
      <b-col
        lg="8"
        class="d-none d-lg-flex align-items-center p-5"
      >
        <div class="w-100 d-lg-flex align-items-center justify-content-center px-5">
          <b-img
            fluid
            :src="imgUrl"
            alt="Login V2"
          />
        </div>
      </b-col>
      <!-- /Left Text-->

      <!-- Login-->
      <b-col
        lg="4"
        class="d-flex align-items-center auth-bg px-2 p-lg-5"
      >
        <b-col
          sm="8"
          md="6"
          lg="12"
          class="px-xl-2 mx-auto"
        >
          <b-card-title
            title-tag="h2"
            class="font-weight-bold mb-1"
          >
            Hesap Girişi
          </b-card-title>
          <b-card-text class="mb-2">
            Oturum Açın
          </b-card-text>

          <!-- form -->
          <validation-observer
            ref="loginForm"
            #default="{ }"
          >
            <b-form
              class="auth-login-form mt-2"
              @submit.prevent="login"
            >
              <!-- email -->
              <b-form-group
                label="E-Posta"
                label-for="login-email"
              >
                <validation-provider
                  #default="{ errors }"
                  name="E-Posta"
                  rules="required|email"
                >
                  <b-form-input
                    id="login-email"
                    v-model="userEmail"
                    :state="errors.length > 0 ? false:null"
                    name="login-email"
                    placeholder="E-Posta"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- forgot password -->
              <b-form-group>
                <div class="d-flex justify-content-between">
                  <label for="login-password">Parola</label>
                  <b-link :to="{name:'forgot-password'}">
                    <small>Parolamı Unuttum</small>
                  </b-link>
                </div>
                <validation-provider
                  #default="{ errors }"
                  name="Parola"
                  rules="required"
                >
                  <b-input-group
                    class="input-group-merge"
                    :class="errors.length > 0 ? 'is-invalid':null"
                  >
                    <b-form-input
                      id="login-password"
                      v-model="password"
                      :state="errors.length > 0 ? false:null"
                      class="form-control-merge"
                      :type="passwordFieldType"
                      name="Parola"
                      placeholder="············"
                    />
                    <b-input-group-append is-text>
                      <feather-icon
                        class="cursor-pointer"
                        :icon="passwordToggleIcon"
                        @click="togglePasswordVisibility"
                      />
                    </b-input-group-append>
                  </b-input-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <!-- submit buttons -->
              <b-button
                type="submit"
                variant="primary"
                block
              >
                Oturum Aç
              </b-button>
            </b-form>
          </validation-observer>
        </b-col>
      </b-col>
    <!-- /Login-->
    </b-row>
  </div>
</template>

<script>
/* eslint-disable global-require */
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import AppLogo from '@core/layouts/components/Logo.vue'
import {
  BRow,
  BCol,
  BLink,
  BFormGroup,
  BFormInput,
  BInputGroupAppend,
  BInputGroup,
  BCardText,
  BCardTitle,
  BImg,
  BForm,
  BButton,
  VBTooltip,
} from 'bootstrap-vue'
import { required, email } from '@validations'
import { togglePasswordVisibility } from '@core/mixins/ui/forms'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import useJwt from '@/auth/jwt/useJwt'
import store from '@/store/index'
import { getHomeRouteForLoggedInUser } from '@/auth/utils'

export default {
  directives: {
    'b-tooltip': VBTooltip,
  },
  components: {
    BRow,
    BCol,
    BLink,
    BFormGroup,
    BFormInput,
    BInputGroupAppend,
    BInputGroup,
    BCardText,
    BCardTitle,
    BImg,
    BForm,
    BButton,
    AppLogo,
    ValidationProvider,
    ValidationObserver,
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      password: '',
      userEmail: '',
      sideImg: require('@/assets/images/pages/login-v2.svg'),
      // validation rules
      required,
      email,
    }
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
    imgUrl() {
      if (store.state.appConfig.layout.skin === 'dark') {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.sideImg = require('@/assets/images/pages/login-v2-dark.svg')
        return this.sideImg
      }
      return this.sideImg
    },

  },
  created() {
    this.setLocale()
  },
  methods: {
    setLocale() {
      const locale = localStorage.getItem('locale')
      if (locale) {
        this.$i18n.locale = locale
      }
    },
    login() {
      this.$refs.loginForm.validate().then(success => {
        if (success) {
          useJwt.login({
            email: this.userEmail,
            password: this.password,
            organizationId: 1,
            siteId: 1,
          })
            .then(response => {
              // Backend'den status false gelirse hata olarak işle
              if (response.data && response.data.status === false) {
                const errorMessage = response.data.message || 'Giriş yapılırken bir hata oluştu'
                this.$toast({
                  component: ToastificationContent,
                  position: 'top-right',
                  props: {
                    title: 'Giriş Hatası',
                    icon: 'XIcon',
                    variant: 'danger',
                    text: errorMessage,
                  },
                })
                return
              }
              const userData = response.data.data.user
              useJwt.setToken(response.data.data.tokens.accessToken)
              useJwt.setRefreshToken(response.data.data.tokens.refreshToken)
              useJwt.setDownloadToken(response.data.data.tokens.downloadToken || null)
              localStorage.setItem('userData', JSON.stringify(userData))
              this.$ability.update(userData.abilities)
              // Realtime socket bağlantısını ayağa kaldır
              try {
                // eslint-disable-next-line global-require
                const { connectSocket } = require('@/libs/socket')
                connectSocket()
              } catch (e) { /* socket optional */ }
              // ? This is just for demo purpose as well.
              // ? Because we are showing eCommerce app's cart items count in navbar
              // this.$store.commit('app-ecommerce/UPDATE_CART_ITEMS_COUNT', userData.extras.eCommerceCartItemsCount)

              // ? This is just for demo purpose. Don't think CASL is role based in this case, we used role in if condition just for ease
              this.$router.replace(getHomeRouteForLoggedInUser(userData.role))
                .then(() => {
                  this.$toast({
                    component: ToastificationContent,
                    position: 'top-right',
                    props: {
                      title: `Merhaba ${userData.name}`,
                      icon: 'CoffeeIcon',
                      variant: 'success',
                      text: 'Oturum açma işleminiz başarılı!',
                    },
                  })
                })
            })
            .catch(error => {
              // Form hatalarını ayarla
              if (error.response?.data?.error) {
                this.$refs.loginForm.setErrors(error.response.data.error)
              } else {
                this.$refs.loginForm.setErrors(error)
              }

              // Hata toast'ı göster
              let errorMessage = 'Giriş yapılırken bir hata oluştu'

              if (error.response?.data?.message) {
                errorMessage = error.response.data.message
              } else if (error.response?.data?.error) {
                // Eğer error objesi varsa, ilk hatayı al
                if (typeof error.response.data.error === 'string') {
                  errorMessage = error.response.data.error
                } else if (Array.isArray(error.response.data.error) && error.response.data.error.length > 0) {
                  const [firstError] = error.response.data.error
                  errorMessage = firstError
                } else if (typeof error.response.data.error === 'object') {
                  const firstError = Object.values(error.response.data.error)[0]
                  errorMessage = Array.isArray(firstError) ? firstError[0] : firstError
                }
              } else if (error.message) {
                errorMessage = error.message
              }

              this.$toast({
                component: ToastificationContent,
                position: 'top-right',
                props: {
                  title: 'Giriş Hatası',
                  icon: 'XIcon',
                  variant: 'danger',
                  text: errorMessage,
                },
              })
            })
        }
      })
    },
    changeLocale(locale) {
      this.$i18n.locale = locale
      localStorage.setItem('locale', locale)
    },
  },
}
</script>
<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';
</style>
<style scoped>
.brand-logo svg{
  width: auto !important;
  height: 40px !important;
}
</style>
